export default __webpack_public_path__ + "media/images/app-icon-2065abc531986fab9070360e42163c79.png";